import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Requisition } from '../../../class/requisition';
import { RequisitionService } from '../../../service/requisition/requisition.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileSurveyService } from '../../../service/profile-survey/profile-survey.service';
import { CustomerGuide } from '../../../class/customer-guide';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { TheftService } from '../../../service/theft/theft.service';

@Component({
  selector: 'app-new-requisition',
  templateUrl: './new-requisition.component.html',
  styleUrls: ['./new-requisition.component.scss']
})
export class NewRequisitionComponent implements OnInit{
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Requisition;
    // @Input() idCustomerGuide: string;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public selectedStatus: {label: string, value: string};
    // public selectedType: {label: string, value: string};
    // public selectedClosingReason: {label: string, value: string};
    public myEmployeeId: string;

    private id: number;
    public showPage: number;

    public statusOptions: any[] = [];
    public typeOptions: SelectItem[];
    public closing_reasonOptions: SelectItem[];

    public temporaryHiringReasonOptions: (SelectItem & {detail: string})[];
    public hiringReasonDescriptionPlaceholder: string = '';

    public publishOfferOptions: any[];

    public customer_guide_id: number;
    public company_id: number;
    public employeePositionToLoad: string;
    public customerGuides: CustomerGuide[];

    public requested_recruitment_var: Boolean =false;

    public es: any;

    public save_exit: boolean;

    public claro_company_id: number = 7;

    public rolesPermissionStatusChange: string = '';
    public modEditProfileSurveyDialog: boolean = false;
    public selectedProfileSurveyForEdit: any = null;

    private readonly profileSurveyRequiredFields = [
      'risk',
      'work_mode',
      'salary_mode',
      'salary_payment_method',
      'workday_schedule',
      'commissions',
    ];

    private readonly profileSurveyFieldLabels: { [key: string]: string } = {
      risk: 'Riesgo ARL',
      work_mode: 'Modalidad de trabajo',
      salary_mode: 'Modalidad salarial',
      salary_payment_method: 'Forma de pago',
      workday_schedule: 'Jornada laboral',
      commissions: 'Comisiones',
    };

    constructor(
        public fb: FormBuilder,
        public requisitionService: RequisitionService,
        public translate: TranslateService,
        public router: Router,
        private route: ActivatedRoute,
        public profileSurveyService: ProfileSurveyService,
        public customerGuideService: CustomerGuideService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.save_exit = false;

        this.es = calendarES();

        this.customerGuides = [];

        this.employeePositionToLoad = '4,5,6,11,38,40,59,68';

        this.rolesPermissionStatusChange = '2,18,20,25';
        var employeeRol = this.getRoleId();

        this.statusOptions = [
          {label: 'Abierto', value: 'Abierto'},
          {label: 'En Proceso', value: 'En Proceso'},
          {label: 'Congelado', value: 'Congelado'},
          {label: 'Cerrado', value: 'Cerrado'},
          {label: 'Cancelado', value: 'Cancelado', disabled: this.enableStatusOptions(employeeRol)},
          {label: 'Retirado', value: 'Retirado'},
          {label: 'Backup', value: 'Backup'},
        ];

        this.typeOptions = [
            {label: 'Proceso de Selección', value: 'Proceso de Selección'},
            {label: 'Enviado por el cliente', value: 'Enviado por el cliente'},
            {label: 'Reingreso', value: 'Reingreso'},
        ];

        this.closing_reasonOptions = [
            {label: 'Baja Producción', value: 'Baja Producción'},
            {label: 'Ingreso De Requisición En Empresa Errada', value: 'Ingreso De Requisición En Empresa Errada'},
            {label: 'Convocatoria Interna Del Cliente', value: 'Convocatoria Interna Del Cliente'},
            {label: 'Retraso En El Cumplimiento De RH', value: 'Retraso En El Cumplimiento De RH'},
            {label: 'Falta De Toma De Decisión Del Cliente', value: 'Falta De Toma De Decisión Del Cliente'},
            {label: 'Cierre Sin Justa Causa', value: 'Cierre Sin Justa Causa'},
            {label: 'Repetición De La Requisición', value: 'Repetición De La Requisición'},
            {label: 'No Se Escribió El Número De Vacantes', value: 'No Se Escribió El Número De Vacantes'},
            {label: 'Cubrimiento De Otra Temporal', value: 'Cubrimiento De Otra Temporal'},
            {label: 'Error En Solicitud De Requisición', value: 'Error En Solicitud De Requisición'},
            {label: 'Cancelación Por El Cliente', value: 'Cancelación Por El Cliente'},
            {label: 'Congelada', value: 'Congelada'},
            {label: 'Error Solicitud Por Parte Del Cliente', value: 'Error Solicitud Por Parte Del Cliente'},
            {label: 'Contratación Directa Por Empresa Usuaria', value: 'Contratación Directa Por Empresa Usuaria'},
            {label: 'Requisición Por Otra Razon Social', value: 'Requisición Por Otra Razon Social'},
            {label: 'Error En Creación De Calidad', value: 'Error En Creación De Calidad'},
            {label: 'Solicitud Mayor A La Real', value: 'Solicitud Mayor A La Real'},
            {label: 'No Se Atendió Por Orden De Gerencia', value: 'No Se Atendió Por Orden De Gerencia'},
            {label: 'Se Contrató La Cantidad Solicitada', value: 'Se Contrató La Cantidad Solicitada'},
            {label: 'Modificación de Perfil', value: 'Modificación de Perfil'},
            {label: 'No Apto Ocupacional', value: 'No Apto Ocupacional'},
            {label: 'Candidato Desiste del Proceso', value:'Candidato Desiste del Proceso'},
            {label: 'No apto en validación', value:'No apto en validación'},
            {label: 'Cambio de analista', value:'Cambio de analista'},
            {label: 'Inejecución', value: 'Inejecución'},
        ];

        this.temporaryHiringReasonOptions = [
          {
            label: "Labores ocasionales, accidentales y/o transitorias",
            value: "Labores ocasionales, accidentales y/o transitorias",
            detail:
              "Aplica para: Tareas ajenas a las actividades normales o al giro ordinario de los negocios de la Empresa Usuaria.\n \nEjemplo: Contratación de un técnico especializado para realizar el mantenimiento correctivo estructural y pintura de las fachadas exteriores del edificio de oficinas principales. Es una actividad de infraestructura ajena a la actividad comercialo misional de la compañía.",
          },
          {
            label: "Reemplazo de personal",
            value: "Reemplazo de personal",
            detail:
              "Aplica para: Sustitución temporal de un trabajador de la planta permanente cuya vinculación se encuentra suspendida o ausente, con derecho legal o convencional a la reserva de su cargo.\n \nEjemplo: Contratación para cubrir temporalmente la vacante de la analista contable durante su licencia materna y hasta su retorno.",
          },
          {
            label:
              "Incrementos en la producción, transporte, ventas y/o prestación de servicios",
            value:
              "Incrementos en la producción, transporte, ventas y/o prestación de servicios",
            detail:
              "Aplica para: Aumento inusual, estacional o pico de demanda extraordinario y transitorio de las actividades habituales de la Empresa Usuaria, que supera la capacidad operativa de la planta de personal actual.\n \nEjemplo: Contratación de operarios logísticos adicionales para el área de despacho, debido al incremento en el volumen de pedidos por la temporada comercial de fin de año.\n \nCampos obligatorios a diligenciar: Descripción del plazo estimado de la necesidad, con soporte que evidencie la transitoriedad del pico (histórico de ventas, órdenes de producción, indicadores de demanda, etc.). Recuerde: el tope legal es de seis (6) meses, prorrogables por seis (6) meses adicionales.",
          },
        ];

        this.publishOfferOptions = [
          {label: 'Sí', value: true},
          {label: 'No', value: false},
        ];
    }

    ngOnInit() {
      this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
      this.id = +this.route.snapshot.paramMap.get('requisition_id');

      // console.log("el id es " + this.id);

      if (this.id !== 0 && (this.id !== undefined)) {
        var _with = 'profile_survey';
        var promiseLoc = this.requisitionService.infoRequisition(this.id,_with).toPromise().then(
          response => {
            //console.log(response);
            this.edit = response.json();
            this.customer_guide_id = this.edit.customer_guide_id;
            this.createForm(this.edit);
            this.loadTemporaryHiringReasonDetail();
            this.updateControlsRecruitment(this.form.controls.requested_recruitment.value);
            this.requested_recruitment_var = this.edit.requested_recruitment;// this.requested_recruitment.setValue(this.edit.requested_recruitment);
            this.changeStatus();
            this.showPage = 1;
          },
          error => {
            this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
            this.router.navigateByUrl('/pages/selection/requisitions');
          }
        );
      }
      else {
        this.route.queryParams.subscribe(params => {
          if (params['customer_guide_id'])
              this.customer_guide_id = params['customer_guide_id'];
          if(params['company_id'])
              this.company_id = params['company_id'];
        });
        this.createForm();
        this.loadTemporaryHiringReasonDetail();
        this.updateControlsRecruitment(this.form.controls.requested_recruitment.value);

        this.selectedStatus = {label: 'Abierto', value: 'Abierto'};
        this.showPage = 1;
      }
    }

    changeStatus(event?:any){
      this.selectedStatus = this.form.controls.status.value;
    }

    public loadTemporaryHiringReasonDetail(selectedValue?: string) {
      const temporaryHiringReasonControl = this.form
        ? this.form.get('temporary_hiring_reason')
        : null;

      const selectedReason = selectedValue !== undefined
        ? selectedValue
        : (temporaryHiringReasonControl ? temporaryHiringReasonControl.value : '');

      const selectedOption = this.temporaryHiringReasonOptions.find(
        option => option.value === selectedReason
      );

      this.hiringReasonDescriptionPlaceholder = selectedOption && selectedOption.detail
        ? selectedOption.detail
        : '';
    }

    createForm(data:any = null) {
      data = data || {
        created_at: undefined,
        venue_id: null,
        destination_id: null,
        company_id: null,
        count: '1',
        max_number_applications: '7',
        count_additional: '0',
        count_hired: '0',
        time_elapsed: '',
        employee_id: null,
        status: 'Abierto',
        type: 'Proceso de Selección',
        regional_claro: '',
        analyst_claro: '',
        referred_claro: '',
        closing_reason: '',
        observation: '',
        // justification: '',
        profile_survey_id: null,
        requested_at: null,

        wait_client: '',
        progress: '',
        requested_recruitment: false,
        quantity_recruitment: '',
        date_request_recruiment: null,
        employee_recruitment_id: null,
        'profile_survey' : {
          estimated_time_requisition: ''
        },

        recruitment_status: null,
        recruitment_closing_date: null,

        temporary_hiring_reason: '',
        hiring_reason_description: '',
        center_cost: '',

        publish_offer: true,
        offer_area_id: null,
        offer_primary_area_id: null
      };

      let get_user_company = this.hasPermission('get user company');
      let edit_permission_req = this.hasPermission('edit requisition');


      this.form = this.fb.group({
        created_at: new FormControl( data.created_at ),
        venue_id: new FormControl( {value: data.venue_id, disabled: !edit_permission_req}, get_user_company ? [] : Validators.compose([Validators.required, Validators.minLength(1)])),
        destination_id: new FormControl( {value: data.destination_id, disabled: !edit_permission_req}, get_user_company ? Validators.compose([Validators.required]) : Validators.compose([Validators.required, Validators.minLength(1)])),
        company_id: new FormControl( {value: data.company_id, disabled: !edit_permission_req || this.edit}, Validators.compose([Validators.required, Validators.minLength(2)])),
        count: new FormControl( {value: data.count, disabled: !edit_permission_req}, Validators.compose([Validators.required])),
        count_additional: new FormControl( {value: data.count_additional, disabled: !edit_permission_req},get_user_company ? [] : Validators.compose([Validators.required])),
        count_hired: new FormControl( {value: data.count_hired, disabled: true}),
        time_elapsed: new FormControl( {value: data.time_elapsed, disabled: !edit_permission_req}),
        employee_id: new FormControl( {value: data.employee_id, disabled: !edit_permission_req}, get_user_company ? [] : Validators.compose([Validators.required, Validators.minLength(1) ]) ),
        status: new FormControl( {value: data.status, disabled: !edit_permission_req}, get_user_company ? [] : Validators.compose([ Validators.required ]) ),
        type: new FormControl( data.type, get_user_company ? [] : Validators.compose([ Validators.required ]) ),
        regional_claro: new FormControl(data.regional_claro),
        analyst_claro: new FormControl(data.analyst_claro),
        referred_claro: new FormControl(data.referred_claro),
        closing_reason: new FormControl( {value: data.closing_reason, disabled: !edit_permission_req} ),
        observation: new FormControl( {value: data.observation, disabled: !edit_permission_req}),
        // justification: new FormControl( {value: data.justification, disabled: !edit_permission_req}),
        profile_survey_id: new FormControl( {value: data.profile_survey_id, disabled: !edit_permission_req }, Validators.compose([Validators.required, Validators.minLength(2)])),
        requested_at: new FormControl( {value: data.requested_at ? new Date(data.requested_at) : data.requested_at, disabled: this.edit}, get_user_company ? [] : Validators.compose([ Validators.required ]) ),
        estimated_time_requisition: new FormControl( {value: data.profile_survey.estimated_time_requisition, disabled: true}),
        wait_client: new FormControl( data.wait_client),
        progress: new FormControl( data.progress),
        requested_recruitment: new FormControl(data.requested_recruitment),
        quantity_recruitment: new FormControl(data.quantity_recruitment,Validators.compose([Validators.pattern("^[0-9]*$")])),
        date_request_recruiment: new FormControl(data.date_request_recruiment ? new Date(data.date_request_recruiment) : data.date_request_recruiment),
        employee_recruitment_id: new FormControl({value: data.employee_recruitment_id, disabled: !this.hasPermission('edit requisition')}),

        recruitment_status: new FormControl(data.recruitment_status),
        recruitment_closing_date: new FormControl(data.recruitment_closing_date),

        temporary_hiring_reason: new FormControl( {value: data.temporary_hiring_reason, disabled: !edit_permission_req}, Validators.compose([ Validators.required, Validators.minLength(2) ]) ),
        hiring_reason_description: new FormControl( {value: data.hiring_reason_description, disabled: !edit_permission_req}, Validators.compose([ Validators.required, Validators.minLength(2) ]) ),
        center_cost: new FormControl(  data.center_cost, Validators.compose([ Validators.required, Validators.maxLength(60) ]) ),

        publish_offer: new FormControl( data.publish_offer, get_user_company ? [] : Validators.compose([ Validators.required ]) ),
        max_number_applications: new FormControl( {value: data.max_number_applications, disabled: !edit_permission_req}, (get_user_company || data.publish_offer == false) ? [] : Validators.compose([ Validators.required,this.controlGreaterThanOtherValidator('max_number_applications','count') ])),
        offer_area_id: new FormControl( data.offer_area_id, get_user_company ? [] : Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
        offer_primary_area_id: new FormControl( data.offer_primary_area_id, get_user_company ? [] : Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
      });

      const temporaryHiringReasonControl = this.form.get('temporary_hiring_reason');
      if (temporaryHiringReasonControl) {
        temporaryHiringReasonControl.valueChanges.subscribe(() => {
          this.loadTemporaryHiringReasonDetail();
        });
      }
    }

    public cancelRequisition () {
      console.log('reset');
      this.form.reset();
      this.close.emit(true);
      this.router.navigateByUrl('/pages/selection/requisitions');
    }

    public newRequisition(values) {

      this.form.get('company_id').enable();
      values.customer_guide_id = values.company_id.customer_guide ? values.company_id.customer_guide.id : values.customer_guide_id;
      values.company_id = values.company_id.id ? values.company_id.id : values.company_id;

      this.assignValue(values, 'employee_id', this.getValueById);
      this.assignValue(values, 'venue_id', this.getValueById);
      this.assignValue(values, 'profile_survey_id', this.getValueById);
      this.assignValue(values, 'requested_at', this.getValueById);
      this.assignValue(values, 'employee_recruitment_id', this.getValueById);

      this.assignValue(values, 'destination_id', this.getValueById);
      this.assignValue(values, 'offer_area_id', this.getValueById);

      // values.closing_reason = values.closing_reason.value;
      // values.status = values.status.value; // values.status ?  values.status.value : null;
      values.requested_at = values.requested_at ? formatDate(values.requested_at) : null;
      // values.type = values.type.value;

      // values.temporary_hiring_reason = (values.temporary_hiring_reason) ? values.temporary_hiring_reason.value : null;

      let recruitment = this.evalueRecruitment(values);

      Object.assign(values, recruitment);

      if (values && this.form.valid) {
          const promise = (this.edit) ?
              this.requisitionService.updateRequisition(this.edit.id, values)
              :
              this.requisitionService.newRequisition(values);

          this.promiseForm = promise.toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.notificationsService.growlNotify('success', res);
                      // this.msg.emit( { severity: 'success', summary: res  } );

                      if (this.save_exit) {
                        this.close.emit(true);
                        this.form.reset();
                        this.save_exit = false;
                        this.router.navigateByUrl('/pages/selection/requisitions');
                      }
                  });
              },
              error => {
                  let msg = '';

                  JSON.parse(error._body).errors.forEach(element => {
                    var err = element;
                    if (element.detail)//
                      err = element.detail;

                    this.translate.get(err).subscribe((res3: string) => {
                      msg = msg + res3 + ', ';
                    });

                  });
                  this.notificationsService.growlNotify('error', '' + msg);

              }
          );
      }
    }

  public evalueRecruitment(values){
    let recruitment = {
      employee_recruitment_id: null,
      date_request_recruiment: null,
      quantity_recruitment: null,
      recruitment_status: null,
      recruitment_closing_date: null,
    };

    if(this.edit){
      if(values.requested_recruitment){
        if(!this.edit.requested_recruitment && !this.edit.recruitment_status)
          values.recruitment_status = 'Abierto';
      }
      else{
        values.recruitment_status = 'No requerido';
        if(this.edit.requested_recruitment)
          values.recruitment_status = 'Cancelado';
      }

      if((values.quantity_recruitment != this.edit.quantity_recruitment)
        || (values.date_request_recruiment != this.edit.date_request_recruiment)
        || (values.employee_recruitment_id != this.edit.employee_recruitment_id))
      {
        if(this.edit.recruitment_closing_date != null){
          values.recruitment_closing_date = null;
        }
      }
    }
    else{
      !values.requested_recruitment ? values.recruitment_status = 'No requerido' : values.recruitment_status = 'Abierto';
    }
    if(values.employee_recruitment_id){
      if(values.employee_recruitment_id.id)
        values.employee_recruitment_id = values.employee_recruitment_id.id;
    }

    recruitment.employee_recruitment_id = values.employee_recruitment_id;
    recruitment.date_request_recruiment = values.date_request_recruiment ? formatDate(values.date_request_recruiment) : values.date_request_recruiment;
    recruitment.quantity_recruitment = values.quantity_recruitment ? values.quantity_recruitment : recruitment.quantity_recruitment;
    recruitment.recruitment_status =  values.recruitment_status;
    recruitment.recruitment_closing_date = values.recruitment_closing_date;

    return recruitment;
  }

  getValueById(var_by_id: any): any {
    var ret_id = undefined;
    if (var_by_id) {
      if (var_by_id.id)
        ret_id = var_by_id.id;
      else
        ret_id = var_by_id;
    }
    return ret_id;
  }

  public assignValue(values, property, getValueFn) {
    if (values.hasOwnProperty(property)) {
      values[property] = getValueFn(values[property]);
    }
  }

  public enableRecruitment(event : any){
    this.requested_recruitment_var = event.checked;
    this.updateControlsRecruitment(this.requested_recruitment_var);
  }

  public saveandexit(values) {
    this.save_exit = true;
    this.newRequisition(values);
  }

  updateControlsRecruitment(varChoose: Boolean){
    var arrayControls = ['quantity_recruitment','date_request_recruiment','employee_recruitment_id'];
    arrayControls.forEach(element =>{
      this.updateValidator(element , varChoose);
    });

  }

  updateValidator(name: string, varChoose: Boolean){
    if(varChoose)
      this.form.get(name).setValidators(Validators.required);
    else
      this.form.get(name).clearValidators();
    this.form.get(name).updateValueAndValidity();
  }

  public selectedCompany(values) {
    if (values.customer_guide) {
      this.customer_guide_id = values.customer_guide.id;
      this.company_id = values.id;
    }
  }

  public onProfileSurveySelected(value: any) {
    const profileSurveyId = this.getProfileSurveyId(value);

    if (!profileSurveyId) {
      return;
    }

    this.validateProfileSurveyCompleteness(profileSurveyId);
  }

  private getProfileSurveyId(value: any): number | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'object' && value.id) {
      return Number(value.id);
    }

    return Number(value);
  }

  private validateProfileSurveyCompleteness(profileSurveyId: number) {
    this.profileSurveyService.infoProfileSurvey(profileSurveyId).toPromise().then(
      response => {
        const profileSurvey = response.json();

        const estimatedTimeControl = this.form ? this.form.get('estimated_time_requisition') : null;
        if (estimatedTimeControl) {
          estimatedTimeControl.setValue(profileSurvey.estimated_time_requisition || '');
        }

        const missingFields = this.profileSurveyRequiredFields.filter(field => this.isEmptyField(profileSurvey[field]));

        if (missingFields.length === 0) {
          this.selectedProfileSurveyForEdit = null;
          return;
        }

        this.selectedProfileSurveyForEdit = profileSurvey;
        this.modEditProfileSurveyDialog = true;

        const missingFieldsLabel = missingFields
          .map(field => this.profileSurveyFieldLabels[field] || field)
          .join(', ');

        this.notificationsService.growlNotify(
          'warn',
          'El perfil de cargo tiene campos pendientes: ' + missingFieldsLabel + '. Complétalos para continuar.'
        );
      },
      () => {
        this.notificationsService.growlNotify('error', 'No fue posible validar el perfil de cargo seleccionado.');
      }
    );
  }

  private isEmptyField(value: any): boolean {
    return value === null || value === undefined || String(value).trim() === '';
  }

  public onCloseProfileSurveyDialog() {
    this.modEditProfileSurveyDialog = false;
    this.selectedProfileSurveyForEdit = null;
  }

  public onSavedProfileSurveyFromDialog() {
    this.modEditProfileSurveyDialog = false;

    const profileSurveyControl = this.form ? this.form.get('profile_survey_id') : null;
    const profileSurveyId = profileSurveyControl ? this.getProfileSurveyId(profileSurveyControl.value) : null;

    if (profileSurveyId) {
      this.validateProfileSurveyCompleteness(profileSurveyId);
    }
  }

  public dateDiff(date_future, date_now) {
    let seconds = Math.floor((date_future - (date_now)) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    const days = Math.floor(hours / 24);
    hours = hours - (days * 24);
    minutes = minutes - (days * 24 * 60) - (hours * 60);
    seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

    return (days + ':' + hours + ':' + minutes + ':' + seconds);
  }

  public gotoProfileSurvey(values) {
    let profile_survey_id = (values.profile_survey_id.id) ? values.profile_survey_id.id : values.profile_survey_id;
    // this.router.navigate(['/pages/profile-survey'], { queryParams: { profile_survey: values.profile_survey_id } });
    window.open('/pages/selection/profile-surveis/' + profile_survey_id + '?token=' + localStorage.getItem('token'));
  }

  public gotoNewProfileSurvey(values) {
    // this.router.navigate(['/pages/profile-survey'], { queryParams: { profile_survey: values.profile_survey_id } });
    window.open('/pages/selection/profile-surveis/0?id_customer_guide=' + this.customer_guide_id + '?token=' + localStorage.getItem('token'));
  }

  public getCustomerGuides() {
    const filters = [];
    if (this.customer_guide_id) {
        filters.push({key: 'id-lk', value: String(this.customer_guide_id)});
    }

    this.customerGuideService.getCustomerGuide(1, 1, undefined, undefined, filters).toPromise().then(
        response => {
            this.customerGuides = response.json().data;
            this.customer_guide_id = this.customerGuides[0].id;
            this.form.controls.company_id.setValue(this.customerGuides[0]);
        },
        error => {
            // this.msgs = [];
            // this.msgs.push( { severity: 'error', summary: 'error' } );
        }
    );
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  getFormValidationErrors(form) {
    let value = '';
    Object.keys(form.controls).forEach(key => {
        const controlErrors: ValidationErrors = this.form.get(key).errors;
        if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
          });
        }
    });
    return (value);
  }

  public hasRole(rol){
    var r: boolean=false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if(role == rol){
      r = true;
    }
    return (r);
  }

  public getRoleId() {
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    return (role);
  }

  public enableStatusOptions(employeeRol){
    var resp = true;
    var array = this.rolesPermissionStatusChange.split(',');

    const elementosEncontrados = array.filter(item => item == employeeRol);
    if(elementosEncontrados.length > 0)
      resp = false;
    return resp;
  }
  public onOfferPrimaryChange(OfferPrimaryAreaId: string)
  {
    // this.form.get('offer_primary_area_id').setValue(OfferPrimaryAreaId);
    this.form.get('offer_area_id').setValue('');
  }
  public enableMaxNumberApplications(name: string, varChoose: Boolean)
  {
    var nameReference = 'count';
    var value1 = this.form.controls[nameReference].value;
    var value2 = 7;
    const result = value1 * value2;
    this.form.get(name).setValue(result);

    if(varChoose)
      this.form.get(name).setValidators([Validators.required,this.controlGreaterThanOtherValidator(name,nameReference)]);
    else{
      this.form.get(name).setValue('0');
      this.form.get(name).clearValidators();
    }

    this.form.get(name).updateValueAndValidity();

  }

  controlGreaterThanOtherValidator(nameControl, nameControlReference)
  {
    return (control:FormControl)=>
    {
      const form=control.parent
      if (form)
      {
        const min=form.get(nameControlReference);
        const max=form.get(nameControl);
        return min.value && max.value && +max.value<=+min.value?{error:'min malue'}:null
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/requisitions/new-requisition/new-requisition.component.ts